<div class="error-dialog-content modal-content">
    <div class="modal-close">
        <a id="error-dialog-close" class="cursor" (click)="onDialogClose()">
            <img src="./assets/icons/close.svg" alt="close" />
        </a>
    </div>
    <div class="modal-title mobile" *ngIf="!isEditFailure">
        {{titleText}}
    </div>
    <div class="modal-subtitle error-subtitle" *ngFor="let error of errorMsgs">
        <p class="mt2 mb2" [innerHTML]="error"></p>
    </div>

    <div class="img-container text-center">
        <img src="./assets/icons/shape.svg" alt="dog">
    </div>

    <div class="button-container sticky-container">
        <button id="closeErrorDialog" class="button" (click)="onDialogClose()">{{ btnText }}</button>
    </div>
</div>